import { createFileRoute } from '@tanstack/react-router';

import { ChecklistsPage } from '@/features/quality/checklists-page';

export const Route = createFileRoute('/_app/projects/$projectId/quality/checklists')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <ChecklistsPage projectId={projectId} />;
}
